import React from 'react';
    import { motion, AnimatePresence } from 'framer-motion';
    import SafeIcon from './common/SafeIcon';
    import * as FiIcons from 'react-icons/fi';

    const BigBlockDisplay = ({ height }) => {
      // Format number with dots for thousands (German style)
      const formattedHeight = height ? height.toLocaleString('de-DE') : '---';

      return (
        <div className="flex flex-col items-center justify-center p-8 z-10 relative">
          <div className="flex items-center gap-2 mb-4 text-gray-400 uppercase tracking-widest text-sm font-semibold">
            <SafeIcon icon={FiIcons.FiLayers} className="text-bitcoin" />
            <span>Aktuelle Blockhöhe</span>
          </div>
          
          <div className="relative">
            {/* Glow Effect behind the number */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-bitcoin/20 blur-[100px] rounded-full pointer-events-none" />
            
            <AnimatePresence mode="wait">
              <motion.h1
                key={height}
                initial={{ y: 20, opacity: 0, scale: 0.9 }}
                animate={{ y: 0, opacity: 1, scale: 1 }}
                exit={{ y: -20, opacity: 0, scale: 0.9 }}
                transition={{ type: "spring", stiffness: 100 }}
                className="text-7xl md:text-9xl font-bold font-mono text-bitcoin select-none tracking-tighter"
                style={{ textShadow: '0 0 40px rgba(247,147,26,0.4)' }}
              >
                {formattedHeight}
              </motion.h1>
            </AnimatePresence>
          </div>

          <motion.div 
            initial={{ opacity: 0 }} 
            animate={{ opacity: 1 }} 
            transition={{ delay: 0.5 }}
            className="mt-6 flex items-center gap-2 text-green-400 text-sm bg-green-400/10 px-3 py-1 rounded-full border border-green-400/20"
          >
            <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse" />
            Live verbunden
          </motion.div>
        </div>
      );
    };

    export default BigBlockDisplay;